import { Directive, ElementRef, AfterViewInit, Input, OnDestroy, Renderer2 } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[tooltipTruncate]',
})
export class TooltipTruncateDirective implements AfterViewInit, OnDestroy {
  @Input() matTooltip: string = ''; // This is the tooltip text
  @Input() tooltipTruncate: string = ''; //Enables truncation checking

  private resizeObserver: ResizeObserver;

  constructor(private el: ElementRef, private tooltip: MatTooltip, private renderer: Renderer2) {
    this.resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => this.updateTooltip());
    });
  }

  ngAfterViewInit(): void {
    // Observes element resizing and enables truncation checking
      this.resizeObserver.observe(this.el.nativeElement);
      this.updateTooltip();
  }

  ngOnDestroy(): void {
    this.resizeObserver.disconnect();
  }

  private updateTooltip(): void {
    const element = this.el.nativeElement;
    const isTruncated = this.isContentOverflowing(element);
    if (isTruncated) {
      this.tooltip.message = this.matTooltip;
    } else {
      this.tooltip.message = '';
      this.tooltip.hide();
    }
  }

  private isContentOverflowing(element: HTMLElement): boolean {
    const clone = element.cloneNode(true) as HTMLElement;
    this.renderer.setStyle(clone, 'position', 'absolute');
    this.renderer.setStyle(clone, 'visibility', 'hidden');
    this.renderer.setStyle(clone, 'white-space', 'nowrap');
    this.renderer.setStyle(clone, 'width', 'auto');
    this.renderer.setStyle(clone, 'display', 'inline-block');

    // Add the clone to the DOM to measure its real size
    const parent = element.parentNode;
    var isOverflowing = false;
    if(parent)
    {
      parent.appendChild(clone);
      isOverflowing = clone.offsetWidth > element.offsetWidth;
      parent.removeChild(clone);
    }

    return isOverflowing;
  }
}
